import React, { useContext, useEffect, useState } from "react";
import { Typography, Button, Backdrop, CircularProgress } from "@mui/material";
import Grid from "@mui/system/Unstable_Grid/Grid";
import { AuthContext } from "../../../context/AuthContext";
import { useSnackbar } from "notistack";
import Input from "../../../shared/components/Input";
import useForm from "../../../shared/hooks/form-hooks";
import {
  VALIDATOR_AUTOCOMPLETE,
  VALIDATOR_NUMBER_ONLY,
  VALIDATOR_VALIDATED,
} from "../../../shared/util/validators";
import axios from "axios";
import { baseUrl } from "../../../baseUrl";

// props: {page, updateReceiptData, rowCount, setIsLoading}
const ReceiptsSearch = (props) => {
  const auth = useContext(AuthContext);
  const { enqueueSnackbar } = useSnackbar();
  const [data, setData] = useState(null);
  const [labNames, setLabNames] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [formState, inputHandler] = useForm(
    {
      name: {
        value: "",
        isValid: true,
      },
      laboratory: {
        value: "",
        isValid: true,
      },
      receiptNumber: {
        value: "",
        isValid: true,
      },
      submissionDate1: {
        value: "",
        isValid: true,
      },
      submissionDate2: {
        value: "",
        isvalid: true,
      },
      price1: {
        value: "",
        isvalid: true,
      },
      price2: {
        value: "",
        isvalid: true,
      },
      isPaid: {
        value: "",
        isvalid: true,
      },
    },
    true
  );

  const searchReceipts = async () => {
    setIsLoading(true);
    axios
      .post(
        `/api/v1/doctors/search-receipts`,
        {
          isPayed: formState.inputs.isPaid.value === "پرداخت شده",
          page: props.page,
          rowCount: props.rowCount,
          ...(formState.inputs.receiptNumber.value && {
            receiptCode: formState.inputs.receiptNumber.value,
          }),
          ...(formState.inputs.name.value && {
            name: formState.inputs.name.value,
          }),
          ...(formState.inputs.laboratory.value && {
            doctorLabId: formState.inputs.laboratory.value.id,
          }),
          ...(formState.inputs.receiptNumber.value && {
            receiptCode: formState.inputs.receiptNumber.value,
          }),
          ...(formState.inputs.submissionDate1.value && {
            submissionDateInterval1: new Date(
              formState.inputs.submissionDate1.value
            ).getTime(),
          }),
          ...(formState.inputs.submissionDate2.value && {
            submissionDateInterval2: new Date(
              formState.inputs.submissionDate2.value
            ).getTime(),
          }),
          ...(formState.inputs.price1.value && {
            totalPriceInterval1: formState.inputs.price1.value,
          }),
          ...(formState.inputs.price2.value && {
            totalPriceInterval2: formState.inputs.price2.value,
          }),
        },
        { headers: { authorization: auth.token } }
      )
      .then((response) => {
        setData(response.data.data);
      })
      .catch((err) => {
        err.data &&
          err.data.map((error) => {
            enqueueSnackbar(error, { variant: "error" });
          });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const getLabsData = async () => {
    try {
      const response = await fetch(
        baseUrl + `/api/v1/doctors/get-laboratorys-doctor`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: auth.token,
          },
        }
      );
      const responseData = await response.json();
      if (!response.ok) {
        throw new Error(response.message);
      }
      setLabNames(
        responseData.data.map((lab) => {
          return {
            name: lab.laboratory[0].user[0].companyName,
            id: lab.laboratory[0].id,
          };
        })
      );
    } catch (err) {
      err.data &&
        err.data.map((error) => {
          enqueueSnackbar(error, { variant: "error" });
        });
    }
  };

  const ReceiptSearchHandler = (e) => {
    e.preventDefault();
    searchReceipts();
  };

  useEffect(() => {
    searchReceipts();
  }, [props.page]);

  useEffect(() => {
    getLabsData();
  }, []);

  useEffect(() => {
    if (data && labNames)
      props.updateReceiptData(data.result, data.pages, labNames);
  }, [data, labNames]);

  const PAIDSTATUS = ["پرداخت شده", "پرداخت نشده"];

  return (
    <>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <form onSubmit={ReceiptSearchHandler}>
        <Grid container spacing={2}>
          <Grid md={3} xs={12}>
            <Input
              id="name"
              element="input"
              label="به نام"
              validators={[VALIDATOR_VALIDATED()]}
              errorText="لطفا به نام را وارد کنید."
              onInput={inputHandler}
              inputValid={true}
              size="small"
            />
          </Grid>
          <Grid md={3} xs={12}>
            <Input
              id="laboratory"
              element="autoComplete"
              label="لابراتوار"
              validators={[VALIDATOR_AUTOCOMPLETE()]}
              errorText="لطفا لابراتوار را انتخاب کنید."
              onInput={inputHandler}
              options={labNames}
              getOptionLabel={(option) => option.name}
              inputValid={true}
              size="small"
            />
          </Grid>
          <Grid md={3} xs={12}>
            <Input
              id="receiptNumber"
              element="input"
              label="شماره فاکتور"
              validators={[VALIDATOR_VALIDATED()]}
              errorText="لطفا شماره فاکتور را وارد نمایید."
              onInput={inputHandler}
              inputValid={true}
              size="small"
            />
          </Grid>
          <Grid md={3} xs={12}>
            <Input
              id="isPaid"
              element="autoComplete"
              label="وضعیت پرداخت"
              validators={[VALIDATOR_AUTOCOMPLETE()]}
              errorText="لطفا وضعیت پرداخت را انتخاب کنید."
              onInput={inputHandler}
              options={PAIDSTATUS}
              inputValid={true}
              getOptionLabel={(pay) => pay}
              size="small"
            />
          </Grid>
          <Grid md={6} xs={12}>
            <Grid md={12}>
              <Typography
                variant="caption"
                display="block"
                gutterBottom
                sx={{ mb: -4, mt: 1 }}
              >
                بازه صدور فاکتور
              </Typography>
            </Grid>
            <Grid md={12}>
              <Input
                id="submissionDate1"
                element="datePick"
                validators={[VALIDATOR_VALIDATED()]}
                errorText="ورودی نامعتبر"
                onInput={inputHandler}
                inputValid={true}
                disabled={false}
                label="شروع"
                disableFuture={true}
                size="small"
                variant="standard"
              />
            </Grid>
            <Grid md={12}>
              <Input
                id="submissionDate2"
                element="datePick"
                validators={[VALIDATOR_VALIDATED()]}
                errorText="ورودی نامعتبر"
                onInput={inputHandler}
                inputValid={true}
                disabled={false}
                label="پایان"
                disableFuture={true}
                size="small"
                variant="standard"
              />
            </Grid>
          </Grid>
          <Grid md={6} xs={12}>
            <Grid md={12}>
              <Typography
                variant="caption"
                display="block"
                gutterBottom
                sx={{ mb: -4, mt: 1 }}
              >
                بازه قیمتی فاکتور
              </Typography>
            </Grid>
            <Grid md={12}>
              <Input
                id="price1"
                element="number_only"
                label="شروع"
                validators={[VALIDATOR_VALIDATED(), VALIDATOR_NUMBER_ONLY()]}
                errorText="لطفا فقط عدد وارد کنید."
                onInput={inputHandler}
                inputValid={true}
                size="small"
                variant="standard"
              />
            </Grid>
            <Grid md={12}>
              <Input
                id="price2"
                element="number_only"
                label="پایان"
                validators={[VALIDATOR_VALIDATED(), VALIDATOR_NUMBER_ONLY()]}
                errorText="لطفا فقط عدد وارد کنید."
                onInput={inputHandler}
                inputValid={true}
                size="small"
                variant="standard"
              />
            </Grid>
          </Grid>
          <Grid xs={12} sm={12}>
            <Button
              type="submit"
              disabled={!formState.isValid}
              fullWidth
              color="secondary"
              variant="outlined"
              size="small"
            >
              جستجو
            </Button>
          </Grid>
        </Grid>
      </form>
    </>
  );
};
export default ReceiptsSearch;
